module.exports = __webpack_public_path__ + "img/placeholder_profile.04eac347.png";